import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

const useStyles = makeStyles(() => ({
    icon: {
        cursor: 'pointer',
        color: '#ff3860', // Matching the delete color
        '&:hover': {
            opacity: 0.7,
        },
    },
}));

const DeleteIcon = ({ className, onClick }) => {
    const classes = useStyles();

    return (
        <DeleteOutlineIcon
            className={`${classes.icon} ${className || ''}`}
            onClick={onClick}
        />
    );
};

DeleteIcon.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func
};

export default DeleteIcon;
